'use strict';

var styled = require('styled-components');
require('./Cells/header.js');
require('react');
require('../Tooltip/component.js');
require('../Icon/component.js');
require('./Cells/headerIcon.styles.js');
var cell = require('./Cells/cell.js');
require('./Cells/cellCheckbox.styles.js');
require('../forms/Select/Control.js');
require('../forms/Select/Option.js');
require('./Cells/cellSelect.styles.js');
require('../forms/Switch/component.js');
require('./Cells/cellSwitch.styles.js');
require('../Text/component.js');
require('./Cells/cellSubText.styles.js');
require('../Pill/pill.styles.js');
require('../Pill/pillButton.styles.js');
require('./Cells/cellPill.styles.js');
require('../Chip/component.js');
require('./Cells/cellChip.styles.js');
require('../Tag/component.js');
require('./Cells/cellTag.styles.js');
require('./Cells/cellActions.js');
require('./Cells/cellIcon.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const FillingDiv = styled__default.default.div `
  margin: 6px 0;
  height: 8px;
  border-radius: 10px;
  background: linear-gradient(0.25turn, ${({ theme }) => `${theme.colors.border}, ${theme.colors.hover}`});

  animation: gradient 3s ease infinite;
  background-size: 200% 200%;
  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;
const TableStyled = styled__default.default.table `
  table-layout: ${({ tableLayout }) => tableLayout};
  border-collapse: collapse;
  width: 100%;
  background-color: white;
  & * {
    vertical-align: revert;
  }

  & th * {
    vertical-align: middle;
  }
`;
const EmptyCell = styled__default.default(cell.Cell) `
  height: inherit;

  & > span {
    height: inherit;
    ${({ $itemsPerPage }) => $itemsPerPage > 5 &&
    `
      position: absolute;
      left: 50%;
      right: 50%;
      top: 156px;
    `}
  }
`;
const EmptyContainer = styled__default.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const IconEmptyContainer = styled__default.default.div `
  width: 122px;
  height: 122px;
`;
const EmptyMainTextContainer = styled__default.default.div `
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  font-size: ${({ theme }) => theme.typography.fontSize.m};
  line-height: ${({ theme }) => theme.typography.lineHeight.m};
  letter-spacing: ${({ theme }) => theme.typography.letterSpacing.s};

  & span:first-child {
    color: ${({ theme }) => theme.colors.primary.normal};
  }
`;
const ActionMenuContainer = styled__default.default.div `
  display: flex;
  margin-bottom: 1rem;
`;
const RightActionMenuContainer = styled__default.default.div `
  margin-left: auto;
`;

exports.ActionMenuContainer = ActionMenuContainer;
exports.EmptyCell = EmptyCell;
exports.EmptyContainer = EmptyContainer;
exports.EmptyMainTextContainer = EmptyMainTextContainer;
exports.FillingDiv = FillingDiv;
exports.IconEmptyContainer = IconEmptyContainer;
exports.RightActionMenuContainer = RightActionMenuContainer;
exports.TableStyled = TableStyled;
//# sourceMappingURL=table.styles.js.map
